import { RouteProps } from 'react-router-dom';
import { appMenu, dashboardPagesMenu, demoPagesMenu, hiddenMenu, pageLayoutTypesPagesMenu } from '../menu';
import DashboardHeader from '../pages/_layout/_headers/DashboardHeader';
import DefaultHeader from '../pages/_layout/_headers/DefaultHeader';

const headers: RouteProps[] = [
    { path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path, element: null },
    { path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path, element: null },
    { path: pageLayoutTypesPagesMenu.blank.path, element: null },
    { path: demoPagesMenu.login.path, element: null },
    { path: demoPagesMenu.signUp.path, element: null },
    { path: demoPagesMenu.page404.path, element: null },
    { path: demoPagesMenu.firstAccess.path, element: null },
    { path: demoPagesMenu.token.path, element: null },
    { path: dashboardPagesMenu.dashboard.path, element: <DashboardHeader /> },
    {
        path: `*`,
        element: <DefaultHeader />,
    },

    /**
     * App Menu
     */
    { path: appMenu.registers.subMenu.companies.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.jobTitles.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.costCenters.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.workResources.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.employees.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.permissions.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.trainings.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.surveys.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.customers.path, element: <DashboardHeader /> },
    { path: appMenu.registers.subMenu.services.path, element: <DashboardHeader /> },
    { path: appMenu.operations.subMenu.surveys.path, element: <DashboardHeader /> },
    { path: appMenu.operations.subMenu.expiringWorkResources.path, element: <DashboardHeader /> },
    { path: appMenu.operations.subMenu.workOrders.path, element: <DashboardHeader /> },

    /**
     * Hidden Menu
     */
    { path: hiddenMenu.workResourceEmployees.path, element: <DashboardHeader /> },
    { path: hiddenMenu.trainingEmployees.path, element: <DashboardHeader /> },
    { path: hiddenMenu.surveySettings.path, element: <DashboardHeader /> },
    { path: hiddenMenu.answeredSurveyDetail.path, element: <DashboardHeader /> },
    { path: hiddenMenu.workOrderDetail.path, element: <DashboardHeader /> },
    { path: hiddenMenu.workOrderView.path, element: <DashboardHeader /> },
];

export default headers;
